import { render, staticRenderFns } from "./gsNewsList.vue?vue&type=template&id=85c333e4&scoped=true"
import script from "./gsNewsList.vue?vue&type=script&lang=js"
export * from "./gsNewsList.vue?vue&type=script&lang=js"
import style0 from "./gsNewsList.vue?vue&type=style&index=0&id=85c333e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c333e4",
  null
  
)

export default component.exports